import { Component, OnInit } from '@angular/core';
import { AppService } from '../../services/app.service';
import { DataService } from '../../services/data.service';
import { PaymentService } from '../../services/payment.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit {
  constructor( private app : AppService , private data : DataService , private _payment : PaymentService , private router : Router) { }
  status : 'warning' | 'success' | 'danger' = 'warning';
  statusMsg : string = "";

  ngOnInit() {
  	
  }
  verifyClient(){
  	this.app.verifyClient()
  			.subscribe(
  				res => {
  					this.AfterVerification()
  				},
  				err => {
  					this.statusMsg = err;
  					this.status = 'danger';
  					console.log(err);
  				}
  			)
  }
  AfterVerification(){
    this.app.getClientProfileData()
	    .subscribe(
	        res => {
	            // let con = {
	            //     clientVerification : res.data.clientVerification
	            // };
	            this.data.setCookieObject('configs' , res.data);
	            this.status = 'success';
  					console.log(res);
	        }
	     );
  }
  goTo(url){
  	this.router.navigate(['settings']);
  }
  reload(){
    window.location.reload();
  }
}
